import { Subject } from './subject.model';
import { SubjectProficiency } from './subject-proficiency.model';

export class Request {
  solicitud: Number;
  fecha: Date;
  tipo: String;
  version: Number;
  cedula: String;
  programa: String;
  estado: String;
  tipoSolicitud: Number;
  materias: Subject[];
  pruebasProficiencia: SubjectProficiency[];
}

